import styled from 'styled-components';
import { screens } from '../../assets/styles/screens';
import colors from '../../assets/styles/colors';

export const ProcessedExceptionContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.bgGray};
`;

export const ProcessedExceptionWrapper = styled.div``;

export const ProcessedExceptionHeader = styled.div``;

export const ProcessedExceptionHeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProcessedExceptionHeaderTitle = styled.small`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

export const ProcessedExceptionContent = styled.div`
  
`;

export const ProcessedExceptionFilterContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  border-top: 1px solid ${colors.grayLight};
  border-bottom: 1px solid ${colors.grayLight};
  display: flex;
  padding: 10px 0px;
`;

export const ProcessedExceptionFilterColumn = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-right: 1px solid ${colors.grayLight};
  padding-left: 15px;
  padding-right: 15px;  

  &:nth-child(1) {
    max-width: 70%;
  }

  &:nth-child(2) {
    max-width: 30%;
    border-right: none;
  }
`;

export const ProcessedExceptionFilterInputSearch = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  margin-left: 26px;
  font-size: 12px;

  ::placeholder,
  ::-webkit-input-placeholder {
    font-size: 12px;
    color: ${colors.textSecondary};
    opacity: 0.9;
    letter-spacing: 0.03em;
    font-family: 'Montserrat', sans-serif;;
  }

  :-ms-input-placeholder {
    font-size: 12px;
    color: ${colors.textSecondary};
    opacity: 0.9;
    letter-spacing: 0.03em;
    font-family: 'Montserrat', sans-serif;;
  }
`;

export const ProcessedExceptionFilterShowContent = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100vh;
  margin-right: 15px;
`;

export const ProcessedExceptionFilterShowOptionSpan = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  color: ${colors.textSecondary};
  margin-right: 15px;
`;

export const ProcessedExceptionFilterShowOptionSelect = styled.div`
  width: 100%;
  position: relative;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const ProcessedExceptionFilterShowOptionContent = styled.div`
  width: 100%;
  left: 0;
  position: absolute;
  display: block;
  top: 30px;
  display: flex;
  flex-direction: column; 
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 10px;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
  transition: ease-in-out .2s;
`;

export const ProcessedExceptionFilterShowOptionSelectOption = styled.div`
  padding: 10px;
  background: ${prop => prop.active ? colors.bgProcessedExceptionFilterSelected : colors.white};
  transition: ease-in-out .2s;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: ${colors.bgSuccess};
  }

  &:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const ProcessedExceptionFilterShowOptionSelected = styled.span`
  font-size: 12px;
  color: ${colors.textPrimary};
`;

export const ProcessedExceptionFilterDisplay = styled.div`
  display: flex;
  background: ${colors.white};
`;

export const ProcessedExceptionListContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 24px;
  padding: 22px 0;
  transition: ease-in-out .2s;
`;

export const ProcessedExceptionEmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
`;

export const ProcessedExceptionEmptyStateParagraph = styled.p`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.bgPrimary};
  margin-top: 20px;
`;
